// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-loader-shell {
  position: relative;
  width: 100%;
}

.app-loader-shell--page {
  min-height: clamp(280px, 56vh, 560px);
}

.app-loader-shell--panel {
  flex: 1 1 auto;
  min-height: 240px;
  height: 100%;
}

.app-loader-shell--card {
  min-height: 220px;
}

.app-loader-shell--compact {
  min-height: 160px;
}

.app-loader-shell--image {
  min-height: 180px;
  border-radius: inherit;
  overflow: hidden;
}

.app-loader-shell--inline {
  min-height: 96px;
}

.app-loader {
  --app-loader-color: #ef4444;
  --app-loader-size: 42px;
  --app-loader-border: 3px;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 1;
}

.app-loader--sm {
  --app-loader-size: 24px;
  --app-loader-border: 2px;
}

.app-loader--lg {
  --app-loader-size: 60px;
  --app-loader-border: 4px;
}

.app-loader--boss,
.app-loader--default {
  --app-loader-color: #ef4444;
}

.app-loader__stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-width: min(100%, 220px);
  max-width: min(100%, 320px);
  padding: 18px 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.03)),
    rgba(10, 10, 10, 0.82);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 18px 52px rgba(0, 0, 0, 0.38);
  backdrop-filter: blur(16px);
}

.app-loader__spinner {
  width: var(--app-loader-size);
  height: var(--app-loader-size);
  border-radius: 50%;
  border: var(--app-loader-border) solid color-mix(in srgb, var(--app-loader-color) 18%, rgba(255, 255, 255, 0.04));
  border-top-color: color-mix(in srgb, var(--app-loader-color) 92%, white 8%);
  box-shadow:
    0 0 0 1px color-mix(in srgb, var(--app-loader-color) 12%, transparent),
    0 0 28px color-mix(in srgb, var(--app-loader-color) 18%, transparent);
  animation: app-loader-spin 0.72s linear infinite;
}

.app-loader__label {
  color: rgba(255, 255, 255, 0.88);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
}

@keyframes app-loader-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .app-loader__spinner {
    animation: none;
    border-top-color: color-mix(in srgb, var(--app-loader-color) 48%, rgba(255, 255, 255, 0.16));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppLoader/AppLoader.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB;;0BAEwB;EACxB;;mCAEiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,iHAAiH;EACjH,2EAA2E;EAC3E;;yEAEuE;EACvE,gDAAgD;AAClD;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;IACf,4FAA4F;EAC9F;AACF","sourcesContent":[".app-loader-shell {\n  position: relative;\n  width: 100%;\n}\n\n.app-loader-shell--page {\n  min-height: clamp(280px, 56vh, 560px);\n}\n\n.app-loader-shell--panel {\n  flex: 1 1 auto;\n  min-height: 240px;\n  height: 100%;\n}\n\n.app-loader-shell--card {\n  min-height: 220px;\n}\n\n.app-loader-shell--compact {\n  min-height: 160px;\n}\n\n.app-loader-shell--image {\n  min-height: 180px;\n  border-radius: inherit;\n  overflow: hidden;\n}\n\n.app-loader-shell--inline {\n  min-height: 96px;\n}\n\n.app-loader {\n  --app-loader-color: #ef4444;\n  --app-loader-size: 42px;\n  --app-loader-border: 3px;\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  z-index: 1;\n}\n\n.app-loader--sm {\n  --app-loader-size: 24px;\n  --app-loader-border: 2px;\n}\n\n.app-loader--lg {\n  --app-loader-size: 60px;\n  --app-loader-border: 4px;\n}\n\n.app-loader--boss,\n.app-loader--default {\n  --app-loader-color: #ef4444;\n}\n\n.app-loader__stack {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-width: min(100%, 220px);\n  max-width: min(100%, 320px);\n  padding: 18px 20px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 18px;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.03)),\n    rgba(10, 10, 10, 0.82);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.05),\n    0 18px 52px rgba(0, 0, 0, 0.38);\n  backdrop-filter: blur(16px);\n}\n\n.app-loader__spinner {\n  width: var(--app-loader-size);\n  height: var(--app-loader-size);\n  border-radius: 50%;\n  border: var(--app-loader-border) solid color-mix(in srgb, var(--app-loader-color) 18%, rgba(255, 255, 255, 0.04));\n  border-top-color: color-mix(in srgb, var(--app-loader-color) 92%, white 8%);\n  box-shadow:\n    0 0 0 1px color-mix(in srgb, var(--app-loader-color) 12%, transparent),\n    0 0 28px color-mix(in srgb, var(--app-loader-color) 18%, transparent);\n  animation: app-loader-spin 0.72s linear infinite;\n}\n\n.app-loader__label {\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.4;\n  text-align: center;\n}\n\n@keyframes app-loader-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .app-loader__spinner {\n    animation: none;\n    border-top-color: color-mix(in srgb, var(--app-loader-color) 48%, rgba(255, 255, 255, 0.16));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
